<template>
  <img
    alt="Animals First logo"
    class="mx-auto h-6 w-auto sm:h-8"
    src="@Assets/images/AnimalsFirst_Logo.png"
  />
</template>
